import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getActionLog, getAllUser, getOperationData } from "@/api/dataAll/actionLog";
import { gmToolNew, gmToolNewPage } from "@/mixins/index";
import { typeList } from '@/api/aymentsdk/aymentsdk';
export default {
  name: "userActionLog",
  mixins: [gmToolNew, gmToolNewPage],
  data: function data() {
    return {
      value2: [],
      tableData: [],
      userList: [],
      total: 0,
      searchData: {
        page_size: 10,
        page: 1,
        user_id: "",
        url: ""
      },
      drawer: false,
      content: "",
      typeList: []
    };
  },
  created: function created() {
    this.getAll();
    this.getsearchDate();
    this.getTypeList();
  },
  methods: {
    getsearchDate: function getsearchDate() {
      var now = new Date(this.$times.zeroTimeZone());
      var year = now.getFullYear();
      var month = (now.getMonth() + 1).toString().length < 2 ? "0" + (now.getMonth() + 1) : now.getMonth() + 1;
      var date = now.getDate().toString().length < 2 ? "0" + now.getDate() : now.getDate();
      var date = year + "-" + month + "-" + date;
      this.value2[0] = date;
      this.value2[1] = date;
    },
    sizeChange: function sizeChange(e) {
      this.searchData.page_size = e;
      this.searchClick(1);
    },
    openParms: function openParms(row) {
      this.content = row.params;
      this.drawer = true;
    },
    datechange: function datechange() {
      if (this.value2.length > 0) {
        this.searchData.starttime = this.value2[0];
        this.searchData.endtime = this.value2[1];
      }
    },
    getAll: function getAll() {
      var _this = this;

      getAllUser().then(function (res) {
        _this.userList = res.data;
      });
    },
    getTypeList: function getTypeList() {
      var _this2 = this;

      getOperationData().then(function (res) {
        _this2.typeList = res.data;
      });
    },
    searchClick: function searchClick(e) {
      var _this3 = this;

      if (this.value2.length > 0) {
        this.searchData.starttime = this.value2[0];
        this.searchData.endtime = this.value2[1];
      }

      this.searchData.page = e;
      getActionLog(this.searchData).then(function (res) {
        _this3.tableData = res.data.data || [];
        _this3.total = res.data.total - 0 || 0;
      });
    },
    exportData: function exportData() {
      var _this4 = this;

      var columns = [{
        label: '用户ID',
        prop: 'user_id'
      }, {
        label: '用户名称',
        prop: 'nickname'
      }, {
        label: '角色',
        prop: 'title'
      }, {
        label: 'IP地址',
        prop: 'ip'
      }, {
        label: '访问地址名称',
        prop: 'city'
      }, {
        label: '操作名称',
        prop: 'url_name'
      }, {
        label: '操作',
        prop: 'url'
      }, {
        label: '时间',
        prop: 'created_at'
      }];
      getActionLog(_objectSpread(_objectSpread({}, this.searchData), {}, {
        page_size: this.total + 10
      })).then(function (res) {
        var data = res.data.data || []; // data.forEach(item => {
        //     item.created_at = this.$times.formDate(item.created_at);
        //   })

        _this4.$export.excel({
          columns: columns,
          data: data,
          title: _this4.$route.meta.title
        });
      });
    }
  }
};